import { toast } from "react-toastify";
import { USER_NOTIFICATIONS } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/** GET `user/notifications/recent` */
export const fetchRecentUserNotifications = async (data = {}) => {
  try {
    const response = await GET(USER_NOTIFICATIONS.RECENT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `user/notifications/metadata` */
export const fetchUserNotificationMetadata = async (data = {}) => {
  try {
    const response = await GET(USER_NOTIFICATIONS.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `user/notifications/filter` */
export const submitUserNotificationFilterData = async (data = {}) => {
  try {
    const response = await POST(USER_NOTIFICATIONS.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `user/notifications/{id}/read` */
export const markUserNotificationAsRead = async (id) => {
  const raw = String(id ?? "").trim();
  if (!raw) return;

  try {
    const response = await POST(USER_NOTIFICATIONS.READ(raw), {});
    return response;
  } catch (error) {
    toast.error(error?.message);
    throw error;
  }
};
